<template>
  <div>
    <div class="loader"></div>
    <p v-if="loadingText" class="loadertext">{{ loadingText }}</p>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    loadingText: { type: String, required: false },
  },
};
</script>
<style>
.loader {
  width: 100%;
  background: url('@/assets/icons/loading.gif') no-repeat center;
  height: 100px;
}
p.loadertext {
  font-size: 16px;
  font-style: italic;
  text-align: center;
}
</style>
